export const CART_KEY = "touchless_cart";

export const loadCart = () => {
  try {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch (err) {
    console.error("loadCart error:", err);
    return [];
  }
};

export const saveCart = (cart) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(cart || []));
  } catch (err) {
    console.error("saveCart error:", err);
  }
};

export const clearCart = () => {
  try {
    localStorage.removeItem(CART_KEY);
  } catch (err) {
    console.error("clearCart error:", err);
  }
};
